import { Component, Input, OnChanges, OnDestroy, SimpleChanges, ElementRef, OnInit, Optional } from '@angular/core';
import { GoogleMap } from '@angular/google-maps';

@Component({
  selector: 'app-map-overlay',
  template: '<div style="position: absolute"><ng-content></ng-content></div>',
  styles: []
})
export class MapOverlayComponent implements OnInit, OnChanges, OnDestroy {
  @Input() latitude: number;
  @Input() longitude: number;

  private overlay: google.maps.OverlayView;

  constructor(
    private elementRef: ElementRef,
    @Optional() private googleMap: GoogleMap
  ) {}

  ngOnInit() {
    this.initOverlay();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.overlay && (changes['latitude'] || changes['longitude'])) {
      this.overlay.draw();
    }
  }

  private initOverlay() {
    const el = this.elementRef.nativeElement.querySelector('div');
    this.overlay = new google.maps.OverlayView();
    
    this.overlay.onAdd = () => {
      const panes = this.overlay.getPanes();
      panes.overlayMouseTarget.appendChild(el);
    };

    this.overlay.draw = () => {
      const projection = this.overlay.getProjection();
      if (!projection) return;

      const latLng = new google.maps.LatLng(this.latitude, this.longitude);
      const pos = projection.fromLatLngToDivPixel(latLng);

      if (pos) {
        el.style.left = (pos.x - el.offsetWidth / 2) + 'px';
        el.style.top = (pos.y - el.offsetHeight / 2) + 'px';
      }
    };

    this.overlay.onRemove = () => {
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      }
    };

    if (this.googleMap) {
      const map = this.googleMap.googleMap;
      if (map) {
        this.overlay.setMap(map);
      } else {
        setTimeout(() => this.initOverlay(), 100);
      }
    }
  }

  ngOnDestroy() {
    if (this.overlay) {
      this.overlay.setMap(null);
    }
  }
}
